<p-dialog
  header="Plano Curricular"
  [modal]="true"
  [(visible)]="visiblePlanoCurricularForm"
  (onHide)="close.emit()"
  [style]="{ width: '40rem' }"
>
  <form [formGroup]="planoCurricularForm" (ngSubmit)="savePlanoCurricular()">
    <div class="p-fluid grid">
      <div class="field col-12 d-flex flex-column">
        <label for="designacao">Designação</label>
        <input inputId="designacao" type="text" pInputText formControlName="designacao" />
        <div class="error-message">
          <p-message
            *ngIf="planoCurricularForm.get('designacao')?.invalid && planoCurricularForm.get('designacao')?.touched"
            severity="error"
            text="Campo obrigatório"
          ></p-message>
        </div>
      </div>

      <div class="field col-12 d-flex flex-column">
        <label for="cargaHoraria">Carga Horária</label>
        <p-inputnumber inputId="cargaHoraria" formControlName="cargaHoraria"></p-inputnumber>
      </div>

      <!-- <div class="field col-6 d-flex flex-column">
        <label for="anoInicio">Ano de Início</label>
        <p-calendar
          inputId="anoInicio"
          formControlName="anoInicio"
          [view]="'year'"
          [dateFormat]="'yy'"
          [yearNavigator]="true"
          [yearRange]="'1900:' + currentYear">
        </p-calendar>
        <div class="error-message">
          <p-message
            *ngIf="planoCurricularForm.get('anoInicio')?.invalid && planoCurricularForm.get('anoInicio')?.touched"
            severity="error"
            text="Campo obrigatório"
          ></p-message>
        </div>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="anoFim">Ano de Fim</label>
        <p-calendar
          inputId="anoFim"
          formControlName="anoFim"
          [view]="'year'"
          [dateFormat]="'yy'"
          [yearNavigator]="true"
          [yearRange]="'1900:' + currentYear">
        </p-calendar>
        <div class="error-message">
          <p-message
            *ngIf="planoCurricularForm.get('anoFim')?.invalid && planoCurricularForm.get('anoFim')?.touched"
            severity="error"
            text="Campo obrigatório"
          ></p-message>
        </div>
      </div> -->

      <div class="field col-12 d-flex flex-column">
        <label for="duracaoAnos">Duração (Anos)</label>
        <input inputId="duracaoAnos" type="number" pInputText formControlName="quantidadeAnosCurricular" />

        <!-- <p-inputnumber inputId="duracaoAnos" formControlName="quantidadeAnosCurricular"></p-inputnumber> -->
        <div class="error-message">
          <p-message
            *ngIf="planoCurricularForm.errors?.['quantidadeAnosCurricular']"
            severity="error"
            text="A duração ou quantidade de anos curriculares não pode exceder 6 anos."
          ></p-message>
        </div>
      </div>
    </div>

    <div class="flex justify-content-between mt-3">
      <p-button label="Cancelar" (click)="close.emit()"></p-button>
      <p-button label="Salvar" class="p-button-primary" type="submit"></p-button>
    </div>
  </form>
</p-dialog>
